import { CODIGOS_ERRO } from '@remoto/shared';
import { ErroApi } from '../../api';

/**
 * Por que um anexo não abre (F6 da revisão de out/2026, ADR-0027, D54).
 *
 * O anexo guardado na MÁQUINA da conversa sai pela máquina depois do cache curto
 * da VPS — e máquina desligada não é "não existe mais": o arquivo está lá, só não
 * dá para buscar agora. As duas frases são diferentes porque pedem gestos
 * diferentes (ligar a máquina, ou desistir), e nenhuma vem com botão que falha.
 */
export function anexoNaMaquinaDesligada(erro: unknown): boolean {
  return erro instanceof ErroApi && erro.codigo === CODIGOS_ERRO.anexoNaMaquinaDesligada;
}

export const FRASE_DA_MAQUINA_DESLIGADA = 'indisponível: a máquina desta conversa está desligada';
